export default __webpack_public_path__ + "static/media/diamond-background.dd47ad19.png";